import axios from "axios";
import { fromJS } from "immutable";
import { FreeRoundsTypes } from "actions/types";

// Rejecting and fetching details make the same request and dispatch the same action; the route
// decides which endpoint is hit.
function requestFreeRounds(route) {
  return (dispatch, getState) => {
    const headers = getState()
      .config.get("headers")
      .toJSON();
    const href = route.get("href");
    const url = `${href}`;
    const method = route.get("method");

    dispatch({
      type: FreeRoundsTypes.FETCH_FREE_ROUNDS_DETAILS,
      payload: {
        route: route,
        method: method,
        headers: headers,
        url: url,
      },
    });

    return axios({
      method,
      headers,
      url,
    }).then(({ data }) => {
      return fromJS(data);
    });
  };
}

export function fetchFreeRoundsReject(route) {
  return requestFreeRounds(route);
}

export function fetchFreeRoundsDetails(route) {
  return requestFreeRounds(route);
}



export function setFreeRoundsDetails(payload) {
  return {
    type: FreeRoundsTypes.SET_FREE_ROUNDS_DETAILS,
    payload,
  };
}
